export interface IOrder {
  id: number;
  title: string;
  link: string;
  comment: string;
  type: IOrderType;
  user_id: number;
  created_at: string;
  updated_at: string;
  original_link: string;
  c_title: string;
  c_image: string;
  c_descr: string;
  vote_count: number;
  pledge_count?: number;
}

export interface IOrderAPI {
  count: number;
  items: IOrder[];
}

export enum IOrderType {
  new = 'new',
  done = 'done',
  canceled = 'cancel',
  skladchina = 'skladchina',
  community = 'community_crowdfunding',
}

export interface IOrderPledger {
  id: number;
  nickname: string;
  email: string;
  created_at: string;
  sub_active: boolean;
}

export interface IPledgersTransfer {
  total: number;
  added: number;
  skipped: number;
}